import { getDeviceType } from './getDeviceType';
const IOS_REG_EXP = /ipad|iphone|ipod/;

// https://github.com/taiga-family/taiga-ui/blob/main/projects/cdk/utils/os/is-apple-platform.ts
const isApplePlatform = navigator => {
  return navigator.platform.startsWith(`Mac`) || navigator.platform === `iPhone`;
};
export const isDesktop = () => getDeviceType() === 'desktop';
export const isIOS = () => {
  var _window;
  return getDeviceType() === 'mobile' && (
  // https://github.com/taiga-family/taiga-ui/blob/main/projects/cdk/utils/os/is-ios.ts
  IOS_REG_EXP.test((_window = window) == null || (_window = _window.navigator) == null ? void 0 : _window.userAgent.toLowerCase()) ||
  // eslint-disable-next-line compat/compat
  isApplePlatform(navigator) && navigator.maxTouchPoints > 1);
};
export const isAndroid = () => getDeviceType() === 'mobile' && !isIOS();